import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.4997 4.52162L6.9997 8.00003L6.99974 5.00665C5.28917 5.46258 4.0145 7.04055 4.00205 8.93738C3.98716 11.2041 5.7805 13.0393 7.99018 13.0538C10.1999 13.0683 12.0171 11.2568 12.032 8.99011C12.0382 8.04865 11.5874 7.11718 11.0004 6.37309C10.8294 6.15629 10.8665 5.84189 11.0833 5.67086C11.3001 5.49984 11.6145 5.53695 11.7855 5.75376C12.4507 6.59698 13.0402 7.74469 13.032 8.99668C13.0136 11.8 10.761 14.072 7.98361 14.0538C5.20618 14.0355 2.98366 11.7342 3.00207 8.93081C3.01809 6.49115 4.72619 4.45391 6.99975 3.97841L6.99979 1L11.4997 4.52162Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }